/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Injury_Explore_StepsInputs */

const en_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore all six steps`)
};

const es_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar los seis pasos`)
};

const de_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle sechs Schritte entdecken`)
};

const zh_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`查看全部六个步骤`)
};

const ar_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف الخطوات الست جميعها`)
};

const fr_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Découvrir les six étapes`)
};

const vi_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khám phá cả sáu bước`)
};

const sw_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chunguza hatua zote sita`)
};

const th_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูทั้งหกขั้นตอน`)
};

const bs_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Istražite svih šest koraka`)
};

const ja_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`六つのステップをすべて見る`)
};

const ko_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여섯 단계 모두 보기`)
};

const pt_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore todos os seis passos`)
};

const it_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri tutti e sei i passi`)
};

const sv_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforska alla sex stegen`)
};

const nl_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ontdek alle zes stappen`)
};

const da_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udforsk alle seks trin`)
};

const nb_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utforsk alle seks trinnene`)
};

const fi_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutki kaikki kuusi vaihetta`)
};

const pl_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj wszystkie sześć kroków`)
};

const ru_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изучить все шесть шагов`)
};

const tr_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altı adımın tümünü keşfedin`)
};

const hi_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी छह चरण देखें`)
};

const id_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi keenam langkah`)
};

const ms_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terokai keenam-enam langkah`)
};

const cs_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prozkoumejte všech šest kroků`)
};

const el_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δείτε και τα έξι βήματα`)
};

const he_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`גלו את כל ששת השלבים`)
};

const af_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verken al ses stappe`)
};

const hu_injury_explore_steps = /** @type {(inputs: Injury_Explore_StepsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fedezd fel mind a hat lépést`)
};

/**
* | output |
* | --- |
* | "Explore all six steps" |
*
* @param {Injury_Explore_StepsInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const injury_explore_steps = /** @type {((inputs?: Injury_Explore_StepsInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Injury_Explore_StepsInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_injury_explore_steps(inputs)
	if (locale === "de") return de_injury_explore_steps(inputs)
	if (locale === "zh") return zh_injury_explore_steps(inputs)
	if (locale === "ar") return ar_injury_explore_steps(inputs)
	if (locale === "fr") return fr_injury_explore_steps(inputs)
	if (locale === "vi") return vi_injury_explore_steps(inputs)
	if (locale === "sw") return sw_injury_explore_steps(inputs)
	if (locale === "th") return th_injury_explore_steps(inputs)
	if (locale === "bs") return bs_injury_explore_steps(inputs)
	if (locale === "ja") return ja_injury_explore_steps(inputs)
	if (locale === "ko") return ko_injury_explore_steps(inputs)
	if (locale === "pt") return pt_injury_explore_steps(inputs)
	if (locale === "it") return it_injury_explore_steps(inputs)
	if (locale === "sv") return sv_injury_explore_steps(inputs)
	if (locale === "nl") return nl_injury_explore_steps(inputs)
	if (locale === "da") return da_injury_explore_steps(inputs)
	if (locale === "nb") return nb_injury_explore_steps(inputs)
	if (locale === "fi") return fi_injury_explore_steps(inputs)
	if (locale === "pl") return pl_injury_explore_steps(inputs)
	if (locale === "ru") return ru_injury_explore_steps(inputs)
	if (locale === "tr") return tr_injury_explore_steps(inputs)
	if (locale === "hi") return hi_injury_explore_steps(inputs)
	if (locale === "id") return id_injury_explore_steps(inputs)
	if (locale === "ms") return ms_injury_explore_steps(inputs)
	if (locale === "cs") return cs_injury_explore_steps(inputs)
	if (locale === "el") return el_injury_explore_steps(inputs)
	if (locale === "he") return he_injury_explore_steps(inputs)
	if (locale === "af") return af_injury_explore_steps(inputs)
	if (locale === "hu") return hu_injury_explore_steps(inputs)
	return en_injury_explore_steps(inputs)
});